import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { fetchLoggedInUserEmail, signOut } from "../api/client.js";
import { getBorrowerEmail } from "../utils/auth.js";

function normalizeEmail(value) {
  return String(value ?? "").trim().toLowerCase();
}

function getExpectedPortalEmail(portal) {
  const fromExpected =
    sessionStorage.getItem("EXPECTED_SESSION_USER") ||
    localStorage.getItem("EXPECTED_SESSION_USER");
  if (fromExpected) return fromExpected;

  if (portal === "lender") {
    return (
      sessionStorage.getItem("ds_lender_email") ||
      localStorage.getItem("ds_lender_email") ||
      sessionStorage.getItem("user") ||
      localStorage.getItem("user") ||
      ""
    );
  }

  if (portal === "borrower") {
    return getBorrowerEmail() || "";
  }

  return sessionStorage.getItem("user") || localStorage.getItem("user") || "";
}

function getSignInPath(portal) {
  if (portal === "borrower") return "/borrower/signin?force=true";
  if (portal === "admin") return "/admin/signin?force=true";
  return "/signin?force=true";
}

/**
 * Detect stale cross-portal sessions (e.g. admin cookie with lender portal flags)
 * and force a clean re-authentication.
 */
export function usePortalSessionGuard(portal) {
  const navigate = useNavigate();
  const checkedRef = useRef(false);

  useEffect(() => {
    if (!portal || checkedRef.current) return;
    checkedRef.current = true;

    let cancelled = false;

    (async () => {
      const expected = normalizeEmail(getExpectedPortalEmail(portal));
      if (!expected) return;

      const actual = await fetchLoggedInUserEmail();
      if (cancelled || !actual || actual === expected) return;

      await signOut();
      if (!cancelled) {
        navigate(getSignInPath(portal), { replace: true });
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [portal, navigate]);
}
